<template>
  <div class="login-wrap">
    <div class="ms-login">
      <div class="ms-title">会展数据管理系统</div>
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="0px"
          class="ms-content"
      >
        <el-form-item prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="phone">
            <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="password-item">
          <el-input
              :type="flag ? 'text' : 'password'"
              placeholder="password"
              v-model="ruleForm.password"
              @keyup.enter.native="submitForm('ruleForm')"
          >
            <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
          </el-input>
          <span
              class="el-icon-lx-attentionfill pass-icon"
              :class="{ 'el-icon-lx-attention': flag }"
              @click="headerPass"
          ></span>
        </el-form-item>
        <div class="login-btn">
          <el-button type="primary" @click="submitForm('ruleForm')"
          >登录
          </el-button
          >
        </div>
      </el-form>
    </div>
    <div class="footer">
      <a v-if="huizhan" href="https://beian.miit.gov.cn"
      >Copyright © 2019 - 2023 闽ICP备2025122415号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data: function () {
    return {
      huizhan: true,
      ruleForm: {
        phone: "",
        password: "",
      },
      rules: {
        phone: [{required: true, message: "请输入手机号码", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
      flag: false,
    };
  },
  created: function () {
    if (
        location.href.indexOf("winsunexpo.com") > 0 ||
        location.href.indexOf("witexpo.cn") > 0
    ) {
      this.huizhan = true;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
              .get(
                  `/Account/Login/${this.ruleForm.phone}/${this.ruleForm.password}`
              )
              .then((res) => {
                if (res.data.hasError == false) {
                  // 存储用户项目
                  localStorage.setItem("ms_username", this.ruleForm.phone);
                  localStorage.setItem("name", res.data.data.name);
                  localStorage.setItem("project_Id", res.data.data.projectId);
                  localStorage.setItem("project", res.data.data.project);
                  localStorage.setItem("roles", res.data.data.roles);
                  // 存储accountId
                  localStorage.setItem("accountId", res.data.data.accountId);
                  if (res.data.data.roles === "超级管理员") {
                    localStorage.setItem("global", true);
                  } else {
                    localStorage.setItem("global", false);
                  }
                  this.$axios
                      .get(`/AccountProjectRole/Project/` + res.data.data.accountId)
                      .then((result) => {
                        if (result.data.hasError === false) {
                          if (res.data.data && result.data.data.length > 0) {
                            localStorage.setItem("time", new Date().getTime());
                          } else {
                            localStorage.setItem("time", new Date().getTime());
                          }
                        } else {
                          localStorage.setItem("global", true);
                        }
                        if (res.data.data.roles === "编辑人员") {
                          this.$router.push("/papers-record");
                        } else {
                          this.$router.push("/dashboard");
                        }
                      });
                } else {
                  this.$message.error(res.data.message);
                }
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    headerPass() {
      this.flag = !this.flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/login-bg.jpg);
  background-size: 100%;
}

.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 350px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.3);
  overflow: hidden;
}

.ms-content {
  padding: 30px 30px;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}

.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}

.password-item {
  position: relative;

  .pass-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>